import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { PermissionRedirect } from '../../account/components/sections'

import { MenuCurationTaskPage, MenuCurationTasksPage } from './pages'

const MenuCurationTasksRouter = () => (
  <>
    <Routes>
      <Route
        index
        element={
          <PermissionRedirect permissions={PERMISSIONS.MENU_CURATION_TASK.LIST}>
            <MenuCurationTasksPage />
          </PermissionRedirect>
        }
      />
      <Route
        path={APP_ROUTES.MENUS.children.MENU_DETAILS.path}
        element={
          <PermissionRedirect
            permissions={[
              PERMISSIONS.MENU_CURATION_TASK.UPDATE,
              PERMISSIONS.MENU_CURATION_TASK.GET,
            ]}
          >
            <MenuCurationTaskPage />
          </PermissionRedirect>
        }
      />
    </Routes>

    <Outlet />
  </>
)

export default MenuCurationTasksRouter
